import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
  Badge,
  Spinner,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
  Form,
  Input,
} from "reactstrap";
import Widget from "../../components/Widget/Widget.js";
import "./table.css";

import optionsIcon from "../../assets/tables/optionsIcon.svg";
import printerIcon from "../../assets/tables/printerIcon.svg";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

import s from "./Tables.module.scss";

import {
  API_TIMEOUT,
  FAKTUR_PERMINTAAN,
  KELUAR_MASUK,
  KELUAR_MASUK_UNIT,
  LOKASI,
  MASUK,
  NERACA,
  PERMINTAAN,
  REKAPAN,
  MASUK_GUDANG,
  SUMBER,
  DATA_OBAT,
} from "../../utils/index.js";
import axios from "axios";

import { useDispatch } from "react-redux";

import Success from "../../assets/success.png";
import { formatDate, logApp, numberWithCommas } from "../../utils/func.js";
import Select, { components } from "react-select";
import swal from "sweetalert";
import { dateTime } from "../../utils/func.js";
import Stop from "../../assets/stop.png";

const TableRekapMasuk = function () {
  const [firstTable, setFirstTable] = useState([]);
  const [secondTable, setSecondTable] = useState([]);
  const [lokasi, setLokasi] = useState("");
  const [level, setLevel] = useState("");
  const [puskesmas, setPuskesmas] = useState("");
  const [unit, setUnit] = useState("");

  const [firstTableCurrentPage, setFirstTableCurrentPage] = useState(0);
  const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0);

  const [modalDelete, setModalDelete] = useState(false);

  const currentYear = new Date().getFullYear();
  const [simpleDropdownValue2, setSimpleDropdownValue2] = useState(
    currentYear.toString()
  );

  const [tahun, setTahun] = useState(currentYear.toString());

  const [currentUser, setCurrentUser] = useState();
  const [idLokasi, setIdLokasi] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [currentFaktur, setCurrentFaktur] = useState("");
  
  // Form state untuk edit
  const [editJumlahMasuk, setEditJumlahMasuk] = useState("");
  const [editHargaSatuan, setEditHargaSatuan] = useState("");
  const [editEd, setEditEd] = useState("");
  const [editTahunPengadaan, setEditTahunPengadaan] = useState("");
  const [editSumber, setEditSumber] = useState("");
  const [listSumber, setListSumber] = useState([]);

  const getDataMasuk = (faktur) => {
    axios({
      method: "get",
      url:
        level == "Dinas"
          ? MASUK + "gudang/" + faktur
          : level == "Puskesmas"
          ? MASUK + "puskesmas/" + faktur
          : MASUK + "unit/" + faktur,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data;
          console.log(data);

          setSecondTable(data);

          //menyesuakian kolom dari permintaan sesuai dengan input dari list
        }
      })
      .catch((error) => {
        // ERROR

        alert(error);
      });
  };

  useEffect(() => {
    if (!currentUser) {
      const currentUser = JSON.parse(localStorage.getItem("user"));
      setCurrentUser(currentUser);
      logApp(currentUser.uid, "Rekapan Masuk");
      setIdLokasi(currentUser.idLokasi);
    }
  }, []);

  const containerStyle = {
    width: "100%",
    height: "300px", // Atur tinggi sesuai kebutuhan Anda
    overflow: "auto",
    /* Gaya tampilan scroll */
    scrollbarWidth: "thin",
    scrollbarColor: "#888888 #f0f0f0",
  };

  useEffect(() => {
    if (idLokasi) {
      ambilDataLokasi();
    }
  }, [idLokasi]);

  useEffect(() => {
    if (level) {
      ambilRekapMasuk(idLokasi);
    }
  }, [level]);

  const ambilDataLokasi = () => {
    axios({
      method: "get",
      url: LOKASI + "ambil/",
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data;
          if (data.length > 0) {
            const fil = data.filter((item) => {
              return idLokasi == item.id;
            });

            const level = fil[0].level;

            if (level == "Puskesmas") {
              setPuskesmas(fil[0].lokasi);
              setUnit("");

              const datafilter = data.filter((item) => {
                return item.id_Puskesmas == fil[0].id;
              });
              let lok = [];
              for (var i = 1; i < datafilter.length; i++) {
                lok.push({
                  value: datafilter[i].id,
                  label: datafilter[i].lokasi,
                  color: "primary",
                });
              }

              setLokasi(lok);
            } else {
              const datafilter = data.filter((item) => {
                return item.id == fil[0].id_Puskesmas;
              });

              setUnit(fil[0].lokasi);

              setPuskesmas(datafilter[0].lokasi);

              setLokasi([
                {
                  value: 74,
                  label: "Pasien",
                  color: "primary",
                },
              ]);
            }
            setLevel(level);
          }
        }
      })
      .catch((error) => {
        // ERROR

        alert(error);
      });
  };

  const ambilRekapMasuk = (id) => {
    setLoading(true);
    axios({
      method: "get",
      url:
        level == "Dinas"
          ? REKAPAN + "masukgudang/"
          : level == "Puskesmas"
          ? REKAPAN + "masukpuskes/" + idLokasi
          : REKAPAN + "masukunit/" + idLokasi,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          setLoading(false);
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data;
          setFirstTable(data);
          setLoading(false);
        }
      })
      .catch((error) => {
        // ERROR
        setLoading(false);
        alert(error);
      });
  };

  const listTahun = [];
  for (let tahun = 2018; tahun <= currentYear; tahun++) {
    listTahun.push({ tahun: tahun });
  }

  const changeSelectDropdownSimple2 = (e) => {
    const select = e.currentTarget.textContent;
    setSimpleDropdownValue2(e.currentTarget.textContent);
    const curAnak = listTahun.filter((item) => {
      return item.tahun == select;
    });

    setTahun(curAnak[0].tahun);
    // ambilDataBantuanKategori(currentBantuan, curAnak[0].tahun);
  };

  const OptionComponent = ({ data, ...props }) => {
    return (
      <components.Option {...props}>
        <div className={`bullet bullet-${data.color} bullet-sm mr-2`}></div>
        {data.label}
      </components.Option>
    );
  };

  const pageSize = 100;
  const pageSize2 = 100;
  const firstTablePagesCount = Math.ceil(firstTable.length / pageSize);
  const secondTablePagesCount = Math.ceil(secondTable.length / pageSize2);

  const setFirstTablePage = (e, index) => {
    e.preventDefault();
    setFirstTableCurrentPage(index);
  };

  const setSecondTablePage = (e, index) => {
    e.preventDefault();
    setSecondTableCurrentPage(index);
  };

  const getFileName = () => {
    const now = new Date();
    const tanggal = now.toISOString().split("T")[0].replace(/-/g, "");
    return `Rekapan_Masuk_${tanggal}`;
  };

  const exportToExcel = () => {
    const table = document.getElementById("neraca_sumber");
    if (!table) {
      swal("Error", "Tabel tidak ditemukan", "error");
      return;
    }

    const wb = XLSX.utils.table_to_book(table, { sheet: "Data" });
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, getFileName() + ".xlsx");
  };

  const exportToPDF = () => {
    const table = document.getElementById("neraca_sumber");
    if (!table) {
      swal("Error", "Tabel tidak ditemukan", "error");
      return;
    }

    const doc = new jsPDF();
    doc.text("Rekapan Masuk", 14, 15);

    const tableData = [];
    const headers = [];

    const thead = table.querySelector("thead");
    if (thead) {
      const headerRows = thead.querySelectorAll("tr");
      headerRows.forEach((row) => {
        const rowData = [];
        row.querySelectorAll("th").forEach((th) => {
          const text = th.textContent.trim();
          if (text) {
            rowData.push(text);
          }
        });
        if (rowData.length > 0) {
          headers.push(rowData);
        }
      });
    }

    const tbody = table.querySelector("tbody");
    if (tbody) {
      tbody.querySelectorAll("tr").forEach((row) => {
        const rowData = [];
        row.querySelectorAll("td").forEach((td) => {
          const text = td.textContent.trim();
          rowData.push(text);
        });
        if (rowData.length > 0) {
          tableData.push(rowData);
        }
      });
    }

    if (headers.length > 0 && tableData.length > 0) {
      doc.autoTable({
        head: headers,
        body: tableData,
        startY: 25,
        styles: { fontSize: 7 },
        headStyles: { fillColor: [66, 139, 202] },
      });
    }

    doc.save(getFileName() + ".pdf");
  };

  const openModal = (data) => {
    console.log(data);

    getDataMasuk(data.noFaktur);
    setCurrentFaktur(data.noFaktur);
    setModalDelete(true);
  };
  const closeModal = () => {
    setSecondTable([]);
    setModalDelete(false);
    setCurrentFaktur("");
  };

  // Ambil data sumber untuk dropdown
  useEffect(() => {
    axios({
      method: "get",
      url: SUMBER,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status === 200) {
          const data = response.data.data;
          const listsum = data.map((item) => {
            return { value: item.id, label: item.sumber };
          });
          setListSumber(listsum);
        }
      })
      .catch((error) => {
        console.error("Error fetching sumber:", error);
      });
  }, []);

  // Fungsi untuk membuka modal edit
  const openEditModal = (item) => {
    setEditingItem(item);
    setEditJumlahMasuk(item.jumlahMasuk || item.total_Masuk || "");
    setEditHargaSatuan(item.hargaSatuan || "");
    setEditEd(item.ed ? item.ed.split("T")[0] : "");
    setEditTahunPengadaan(item.tahunPengadaan || "");
    
    // Set sumber berdasarkan id atau nama
    if (item.sumber) {
      const sumberItem = listSumber.find(s => s.label === item.sumber);
      if (sumberItem) {
        setEditSumber(sumberItem.value);
      }
    }
    
    setModalEdit(true);
  };

  // Fungsi untuk menutup modal edit
  const closeEditModal = () => {
    setModalEdit(false);
    setEditingItem(null);
    setEditJumlahMasuk("");
    setEditHargaSatuan("");
    setEditEd("");
    setEditTahunPengadaan("");
    setEditSumber("");
  };

  // Fungsi untuk handle edit
  const handleEdit = () => {
    if (!editingItem) return;

    swal({
      title: "Konfirmasi Edit",
      text: `Apakah Anda yakin ingin mengedit data obat "${editingItem.nama}"?`,
      icon: "warning",
      buttons: ["Batal", "Edit"],
      dangerMode: false,
    }).then((willEdit) => {
      if (willEdit) {
        const editData = {
          id: editingItem.id,
          id_dataObat: editingItem.id_dataObat,
          jumlahMasuk: parseInt(editJumlahMasuk),
          harga: parseFloat(editHargaSatuan),
          ed: editEd,
          tahunPengadaan: parseInt(editTahunPengadaan),
          sumber: parseInt(editSumber),
        };

        axios({
          method: "patch",
          url: MASUK + "gudang/edit",
          data: editData,
          timeout: API_TIMEOUT,
        })
          .then((response) => {
            if (response.status === 200 && response.data.success === 1) {
              swal("Sukses", "Data berhasil diupdate", "success");
              closeEditModal();
              // Refresh data
              if (currentFaktur) {
                getDataMasuk(currentFaktur);
              }
            } else {
              swal("Error", "Gagal mengupdate data", "error");
            }
          })
          .catch((error) => {
            console.error("Error updating data:", error);
            swal("Error", "Terjadi kesalahan saat mengupdate data", "error");
          });
      }
    });
  };

  // Fungsi untuk handle delete
  const handleDelete = (item) => {
    swal({
      title: "Konfirmasi Hapus",
      text: `Apakah Anda yakin ingin menghapus data obat "${item.nama}"? Data yang dihapus tidak dapat dikembalikan!`,
      icon: "warning",
      buttons: ["Batal", "Hapus"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axios({
          method: "delete",
          url: MASUK + "gudang/delete",
          data: {
            id: item.id,
            id_dataObat: item.id_dataObat,
          },
          timeout: API_TIMEOUT,
        })
          .then((response) => {
            if (response.status === 200 && response.data.success === 1) {
              swal("Sukses", "Data berhasil dihapus", "success");
              // Refresh data
              if (currentFaktur) {
                getDataMasuk(currentFaktur);
              }
            } else {
              swal("Error", "Gagal menghapus data", "error");
            }
          })
          .catch((error) => {
            console.error("Error deleting data:", error);
            swal("Error", "Terjadi kesalahan saat menghapus data", "error");
          });
      }
    });
  };

  return (
    <div>
      <Row>
        <Col>
          <Row className="mb-4">
            <Col>
              <Widget>
                <div className={s.tableTitle}>
                  <div className="headline-2">
                    Daftar Faktur <code>{"Masuk"}</code>
                  </div>
                  <div>
                    {" "}
                    <Button
                      color="success"
                      size="sm"
                      onClick={exportToExcel}
                      className="btnKu"
                      style={{ height: "32px", padding: "0.25rem 0.75rem" }}
                    >
                      <i className="fa fa-file-excel-o mr-2" />
                      Export Excel
                    </Button>
                    <Button
                      color="danger"
                      size="sm"
                      onClick={exportToPDF}
                      className="btnKu"
                      style={{ height: "32px", padding: "0.25rem 0.75rem" }}
                    >
                      <i className="fa fa-file-pdf-o mr-2" />
                      Export PDF
                    </Button>
                  </div>

                  <div className="d-flex">
                    <Col className="pr-grid-col" xs={4}>
                      <UncontrolledButtonDropdown>
                        <DropdownToggle caret color="primary">
                          {simpleDropdownValue2}
                        </DropdownToggle>

                        <DropdownMenu>
                          {listTahun &&
                            listTahun.map((item) => (
                              <DropdownItem
                                onClick={changeSelectDropdownSimple2}
                              >
                                {item.tahun}
                              </DropdownItem>
                            ))}
                        </DropdownMenu>
                      </UncontrolledButtonDropdown>
                    </Col>
                  </div>
                </div>
                <div className="widget-table-overflow">
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ minHeight: "200px" }}
                    >
                      <Spinner color="primary" />
                      <span className="ml-3">Memuat data...</span>
                    </div>
                  ) : (
                    <>
                  <Table
                    className={`table-striped table-borderless table-hover ${s.statesTable}`}
                    id="neraca_sumber"
                    responsive
                  >
                    <thead>
                      <tr>
                        <th className={s.checkboxCol}>No</th>
                        <th className="w-25">Faktur</th>

                        <th className="w-25">TANGGAL MASUK</th>

                        <th className="w-25">STATUS</th>

                        <th className="w-25">JUMLAH OBAT</th>
                        <th className="w-25">TOTAL HARGA</th>

                        <th className="w-25">PETUGAS</th>

                        <th className="w-25">ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {firstTable
                        .slice(
                          firstTableCurrentPage * pageSize,
                          (firstTableCurrentPage + 1) * pageSize
                        )
                        .map((item, index) => (
                          <tr key={uuidv4()}>
                            <td>{index + 1}</td>
                            <td className="d-flex align-items-center">
                              <span className="ml-3">{item.noFaktur}</span>
                            </td>

                            <td>{formatDate(item.tanggalMasuk)}</td>

                            <td>
                              {
                                <img
                                  style={{ width: 25, height: 25 }}
                                  src={Success}
                                />
                              }
                            </td>
                            <td>{numberWithCommas(item.jumlahObat)}</td>
                            <td>{numberWithCommas(item.totalHarga)}</td>

                            <td>{item.nama}</td>

                            <td>
                              <Button
                                className={`${s.controlBtn} mx-2`}
                                color="primary"
                                size="xs"
                                onClick={() => {
                                  openModal(item);
                                }}
                              >
                                Data
                              </Button>
                            </td>

                            <td></td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                  <Pagination
                    className="pagination-borderless"
                    aria-label="Page navigation example"
                  >
                    <PaginationItem disabled={firstTableCurrentPage <= 0}>
                      <PaginationLink
                        onClick={(e) =>
                          setFirstTablePage(e, firstTableCurrentPage - 1)
                        }
                        previous
                        href="#top"
                      />
                    </PaginationItem>
                    {[...Array(firstTablePagesCount)].map((page, i) => (
                      <PaginationItem
                        active={i === firstTableCurrentPage}
                        key={i}
                      >
                        <PaginationLink
                          onClick={(e) => setFirstTablePage(e, i)}
                          href="#top"
                        >
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}
                    <PaginationItem
                      disabled={
                        firstTableCurrentPage >= firstTablePagesCount - 1
                      }
                    >
                      <PaginationLink
                        onClick={(e) =>
                          setFirstTablePage(e, firstTableCurrentPage + 1)
                        }
                        next
                        href="#top"
                      />
                    </PaginationItem>
                  </Pagination>
                    </>
                  )}
                </div>
              </Widget>
            </Col>
          </Row>
        </Col>
      </Row>
      <Modal size="lg" isOpen={modalDelete} toggle={() => closeModal()}>
        <ModalHeader toggle={() => closeModal()}>
          <div className={s.tableTitle}>
            <div className="headline-2">
              Daftar Obat
              <code> Masuk </code>
            </div>
            <div className="d-flex">
              <Button
                color="success"
                size="sm"
                onClick={() => {
                  const table = document.getElementById("dataBantuan");
                  if (!table) {
                    swal("Error", "Tabel tidak ditemukan", "error");
                    return;
                  }
                  const now = new Date();
                  const tanggal = now
                    .toISOString()
                    .split("T")[0]
                    .replace(/-/g, "");
                  const wb = XLSX.utils.table_to_book(table, { sheet: "Data" });
                  const excelBuffer = XLSX.write(wb, {
                    bookType: "xlsx",
                    type: "array",
                  });
                  const data = new Blob([excelBuffer], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  saveAs(data, `faktur_minta_${tanggal}.xlsx`);
                }}
                className="btnKu"
                style={{ height: "32px", padding: "0.25rem 0.75rem" }}
              >
                <i className="fa fa-file-excel-o mr-2" />
                Excel
              </Button>
              <Button
                color="danger"
                size="sm"
                onClick={() => {
                  const table = document.getElementById("dataBantuan");
                  if (!table) {
                    swal("Error", "Tabel tidak ditemukan", "error");
                    return;
                  }
                  const now = new Date();
                  const tanggal = now
                    .toISOString()
                    .split("T")[0]
                    .replace(/-/g, "");
                  const doc = new jsPDF();
                  doc.text("Faktur Minta", 14, 15);

                  const tableData = [];
                  const headers = [];

                  const thead = table.querySelector("thead");
                  if (thead) {
                    const headerRows = thead.querySelectorAll("tr");
                    headerRows.forEach((row) => {
                      const rowData = [];
                      row.querySelectorAll("th").forEach((th) => {
                        const text = th.textContent.trim();
                        if (text) {
                          rowData.push(text);
                        }
                      });
                      if (rowData.length > 0) {
                        headers.push(rowData);
                      }
                    });
                  }

                  const tbody = table.querySelector("tbody");
                  if (tbody) {
                    tbody.querySelectorAll("tr").forEach((row) => {
                      const rowData = [];
                      row.querySelectorAll("td").forEach((td) => {
                        const text = td.textContent.trim();
                        rowData.push(text);
                      });
                      if (rowData.length > 0) {
                        tableData.push(rowData);
                      }
                    });
                  }

                  if (headers.length > 0 && tableData.length > 0) {
                    doc.autoTable({
                      head: headers,
                      body: tableData,
                      startY: 25,
                      styles: { fontSize: 7 },
                      headStyles: { fillColor: [66, 139, 202] },
                    });
                  }

                  doc.save(`faktur_minta_${tanggal}.pdf`);
                }}
                  className="btnKu"
                style={{ height: "32px", padding: "0.25rem 0.75rem" }}
              >
                <i className="fa fa-file-pdf-o mr-2" />
                PDF
              </Button>
              <a>
                <img src={printerIcon} alt="Printer" />
              </a>
              <a>
                <img
                  className="d-none d-sm-block"
                  src={optionsIcon}
                  alt="Options"
                />
              </a>
              <a>
                <img
                  style={{ width: 30, height: 30 }}
                  src={Success}
                  alt="Funnel"
                />
              </a>
            </div>
          </div>
        </ModalHeader>

        <Widget className="widget-p-md">
          <div className="widget-table-overflow">
            <Table
              id="dataBantuan"
              className={`table-striped table-borderless table-hover ${s.statesTable}`}
              responsive
            >
              <thead>
                <tr>
                  <th className={s.checkboxCol}>
                    <div className="checkbox checkbox-primary">
                      <input
                        className="styled"
                        id="checkbox100"
                        type="checkbox"
                      />
                      <label for="checkbox100" />
                    </div>
                  </th>
                  <th className="w-25">Obat</th>
                  <th className="w-25">Satuan</th>

                  <th className="w-25">Jumlah</th>
                  <th className="w-25">Harga Satuan</th>
                  <th className="w-25">Total Harga</th>

                  <th className="w-25">Sumber</th>
                  <th className="w-25">Tahun Pengadaan</th>
                  <th className="w-25">Expired Date</th>
                  <th className="w-25">Action</th>
                </tr>
              </thead>
              <tbody>
                {secondTable
                  .slice(
                    secondTableCurrentPage * pageSize2,
                    (secondTableCurrentPage + 1) * pageSize2
                  )
                  .map((item) => (
                    <tr key={uuidv4()}>
                      <td>
                        <div className="checkbox checkbox-primary">
                          <input
                            id={item.nama}
                            className="styled"
                            type="checkbox"
                          />
                          <Label for={item.nama} />
                        </div>
                      </td>
                      <td className="d-flex align-items-center">
                        <span className="ml-3">{item.nama}</span>
                      </td>

                      <td>{item.satuan}</td>
                      <td>
                        {level == "Dinas"
                          ? item.jumlahMasuk && numberWithCommas(item.jumlahMasuk)
                          : item.total_Masuk &&
                            numberWithCommas(item.total_Masuk)}
                      </td>
                      <td>
                        Rp.
                        {item.hargaSatuan && numberWithCommas(item.hargaSatuan)}
                      </td>
                      <td>
                        Rp.
                        {item.totalHarga && numberWithCommas(item.totalHarga)}
                      </td>

                      <td>{item.sumber}</td>
                      <td>{item.tahunPengadaan}</td>
                      <td>{formatDate(item.ed)}</td>
                      <td>
                        <Button
                          className={`${s.controlBtn} mx-1`}
                          color="primary"
                          size="xs"
                          onClick={() => openEditModal(item)}
                        >
                          Edit
                        </Button>
                        <Button
                          className={`${s.controlBtn} mx-1`}
                          color="danger"
                          size="xs"
                          onClick={() => handleDelete(item)}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
            <Pagination
              className="pagination-borderless"
              aria-label="Page navigation example"
            >
              <PaginationItem disabled={secondTableCurrentPage <= 0}>
                <PaginationLink
                  onClick={(e) =>
                    setSecondTablePage(e, secondTableCurrentPage - 1)
                  }
                  previous
                  href="#top"
                />
              </PaginationItem>
              {[...Array(secondTablePagesCount)].map((page, i) => (
                <PaginationItem active={i === secondTableCurrentPage} key={i}>
                  <PaginationLink
                    onClick={(e) => setSecondTablePage(e, i)}
                    href="#top"
                  >
                    {i + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}
              <PaginationItem
                disabled={secondTableCurrentPage >= secondTablePagesCount - 1}
              >
                <PaginationLink
                  onClick={(e) =>
                    setSecondTablePage(e, secondTableCurrentPage + 1)
                  }
                  next
                  href="#top"
                />
              </PaginationItem>
            </Pagination>
          </div>
        </Widget>
      </Modal>

      {/* Modal Edit */}
      <Modal size="lg" isOpen={modalEdit} toggle={() => closeEditModal()}>
        <ModalHeader toggle={() => closeEditModal()}>
          Edit Data Obat Masuk
        </ModalHeader>
        <ModalBody>
          {editingItem && (
            <Form>
              <FormGroup>
                <Label>Nama Obat</Label>
                <Input
                  type="text"
                  value={editingItem.nama || ""}
                  disabled
                  readOnly
                />
              </FormGroup>
              <FormGroup>
                <Label>Jumlah Masuk</Label>
                <Input
                  type="number"
                  value={editJumlahMasuk}
                  onChange={(e) => setEditJumlahMasuk(e.target.value)}
                  placeholder="Masukkan jumlah"
                />
              </FormGroup>
              <FormGroup>
                <Label>Harga Satuan</Label>
                <Input
                  type="number"
                  step="0.01"
                  value={editHargaSatuan}
                  onChange={(e) => setEditHargaSatuan(e.target.value)}
                  placeholder="Masukkan harga satuan"
                />
              </FormGroup>
              <FormGroup>
                <Label>Expired Date</Label>
                <Input
                  type="date"
                  value={editEd}
                  onChange={(e) => setEditEd(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <Label>Tahun Pengadaan</Label>
                <Input
                  type="number"
                  value={editTahunPengadaan}
                  onChange={(e) => setEditTahunPengadaan(e.target.value)}
                  placeholder="Masukkan tahun pengadaan"
                  min="2000"
                  max={currentYear + 10}
                />
              </FormGroup>
              <FormGroup>
                <Label>Sumber</Label>
                <Select
                  options={listSumber}
                  value={listSumber.find((s) => s.value === editSumber)}
                  onChange={(selected) =>
                    setEditSumber(selected ? selected.value : "")
                  }
                  placeholder="Pilih sumber"
                  isClearable
                />
              </FormGroup>
            </Form>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => closeEditModal()}>
            Batal
          </Button>
          <Button color="primary" onClick={handleEdit}>
            Simpan Perubahan
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default TableRekapMasuk;
